
<workflow-no-access [workflowTargetInfo]="workflowTargetInfo"></workflow-no-access>
<div class="container" [hidden]="!workflowTargetInfo.correctRole" [ngClass]="{'general-disabled':project.isMigrationActive}">
  <div class="row">
    <div class="col p-0" *ngIf="!project.k2Customer">
      <div class="alert alert-warning"><span>Select a Customer</span></div>
    </div>
    <div class="col pl-0" *ngIf="project.k2Customer">
      <div class="alert alert-info"><span>Current Customer: {{project.k2CustomerName}}</span><a class="btn btn-outline-primary btn-sm float-right" (click)="editCustomHeaders()" *ngIf="project.k2Customer">Edit Custom Headers</a>
        <div class="clearfix"></div>
      </div>
    </div>
    <div class="col-md-4 pr-0">
      <div class="float-right pb-2">
        <div class="btn-group mt-2"><a class="btn btn-primary" [href]="'#/workflow/' + workflowService.workflowConfig.id + '/selectTargetCustomer/setupCustomer'">Create Customer</a>
          <button class="btn btn-warning" (click)="clearSelection()" *ngIf="project.k2Customer">Clear Selection</button>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
  <div class="row">
    <div class="col table-card">
      <list-controls [search]="searchText" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="totalCount" (onChange)="onListControlsChange($event)"></list-controls>
      <table class="table table-responsive customer-table">
        <thead>
          <tr class="table-header-with-controls">
            <th>Name</th>
            <th class="contract">Contract Number</th>
            <th class="actions">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let customer of customers; let idx = index;">
            <td class="name">{{customer.name}}</td>
            <td>{{customer.contractNumber}}</td>
            <td>
              <button class="btn btn-primary btn-sm" *ngIf="project.k2Customer !== customer.id" (click)="setCustomer(customer)">Select Customer</button><span class="font-italic text-muted" *ngIf="project.k2Customer === customer.id">Current customer</span>
            </td>
          </tr>
          <tr *ngIf="customers.length === 0">
            <td colspan="7">
              <p class="text-center empty-table-message">There are no customers to display.</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>